import React, { Component } from 'react'

import './chevron.scss'

import Icon from '../icon'
import { ElementIcons } from '../icons'

class Expand extends Component {
  constructor (props) {
    super(props)
    this.onClick = this.onClick.bind(this)
  }

  onClick (e) {
    if (typeof this.props.onClick === 'function') {
      this.props.onClick(e)
    }
  }

  render () {
    let chevronClass = 'element-chevron__right'
    if (this.props.open) {
      chevronClass = 'element-chevron__down'
    }

    return (
      <div className='element-chevron' onClick={this.onClick}>
        {this.props.isOpenUp && <Icon icon={ElementIcons.Chevron_Right} className={'chevron_up'} injectSvg />}
        <Icon icon={ElementIcons.Chevron_Right} className={chevronClass} injectSvg />
      </div>
    )
  }
}

Expand.defaultProps = {
  open: false,
  isOpenUp: false
}

export default Expand



// WEBPACK FOOTER //
// ./src/app/shared/elements/chevron/index.js